import {
  Container,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Typography,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { laboratoryServices } from "../../services";
import { AuthContext } from "../../context";
export default function ConsentForm({
  onSubmit,
  defaultValues,
  isEdit = false,
  loading = false,
}) {
  const {
    register,
    handleSubmit,
    errors,
    reset,
    control,
    watch,
    setValue,
    trigger,
  } = useForm({
    defaultValues: defaultValues || {
      name: "",
      type: "",
      target: "",
      laboratoryId: "UNIO",
      childLaboratoryId: "",
      file: null,
    },
  });
  const { authState, signOut } = useContext(AuthContext);
  const [labs, setLabs] = useState(null);
  const [childLlabs, setChildLabs] = useState(null);
  const [loadingChildLabs, setLoadingChildLabs] = useState(false);
  const [loadingLabs, setLoadingLabs] = useState(true);

  useEffect(() => {
    async function getLaboratories() {
      try {
        const { status, response } = await laboratoryServices.getLaboratories({
          page: 1,
          limit: 999,
          token: authState.token,
        });
        setLoadingLabs(false);
        if (status === 200) {
          setLabs(response.laboratories);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    }
    getLaboratories();
  }, []);
  useEffect(() => {
    if (isEdit && defaultValues) {
      reset({
        name: defaultValues.name,
      });
    }
  }, [defaultValues]);

  const mainLaboratoryId = watch("laboratoryId");
  useEffect(() => {
    const getChildLabs = async () => {
      setLoadingChildLabs(true);
      try {
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            page: 1,
            limit: 999,
            token: authState.token,
            laboratoryId: mainLaboratoryId,
            text: "",
          });
        setLoadingChildLabs(false);
        if (status === 200) {
          setChildLabs(response.laboratories);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (mainLaboratoryId === "UNIO" || isEdit) return;
    getChildLabs();
    setValue("childLaboratoryId", "");
  }, [mainLaboratoryId]);

  const consentType = watch("type");
  useEffect(() => {
    setValue("target", "");
  }, [consentType]);
  const owner = watch("laboratoryId");
  return (
    <Container maxWidth="sm" style={{ padding: 0 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Nombre */}
        <TextField
          label="Nombre"
          variant="outlined"
          size="small"
          margin="normal"
          fullWidth
          name={`name`}
          inputRef={register({
            required: "Nombre requerido",
          })}
          error={errors.name ? true : false}
          helperText={errors.name ? errors.name.message : ""}
          disabled={loading}
          {...(isEdit ? { InputLabelProps: { shrink: true } } : {})}
        />
        {/* father lab */}
        {!isEdit && (
          <FormControl
            variant="outlined"
            size="small"
            fullWidth
            margin="normal"
            error={!!errors.laboratoryId}
            disabled={loadingLabs}
          >
            <InputLabel>Laboratorio</InputLabel>
            <Controller
              name="laboratoryId"
              control={control}
              defaultValue=""
              rules={{ required: "El laboratorio es obligatorio" }}
              as={
                <Select label="Laboratorio">
                  <MenuItem value="UNIO">Unio</MenuItem>
                  {labs?.map((lab) => (
                    <MenuItem key={lab._id} value={lab._id}>
                      {lab.name}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>{errors.laboratoryId?.message}</FormHelperText>
          </FormControl>
        )}
        {/* Child lab */}
        {!isEdit && (
          <FormControl
            variant="outlined"
            size="small"
            fullWidth
            margin="normal"
            error={!!errors.childLaboratoryId}
            disabled={loadingChildLabs}
          >
            <InputLabel>Unidad de negocio</InputLabel>
            <Controller
              name="childLaboratoryId"
              control={control}
              defaultValue=""
              // rules={{ required: "El laboratorio es obligatorio" }}
              as={
                <Select
                  label="Unidad de negocio"
                  endAdornment={
                    loadingChildLabs ? (
                      <InputAdornment position="end">
                        <CircularProgress size={18} color="inherit" />
                      </InputAdornment>
                    ) : null
                  }
                >
                  <MenuItem value="">
                    <em>No option</em>
                  </MenuItem>
                  {childLlabs?.map((lab) => (
                    <MenuItem key={lab._id} value={lab._id}>
                      {lab.name}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>{errors.laboratoryId?.message}</FormHelperText>
          </FormControl>
        )}
        {/* Type */}
        {!isEdit && (
          <FormControl
            variant="outlined"
            size="small"
            fullWidth
            margin="normal"
            error={!!errors.type}
            disabled={loading}
          >
            <InputLabel>Tipo</InputLabel>
            <Controller
              name="type"
              control={control}
              defaultValue=""
              rules={{ required: "El tipo es obligatorio" }}
              as={
                <Select label="Tipo">
                  <MenuItem value="ASSIGNMENT">Asignación</MenuItem>
                  {owner === "UNIO" && (
                    <MenuItem value="REGISTER">Registro</MenuItem>
                  )}
                </Select>
              }
            />
            <FormHelperText>{errors.type?.message}</FormHelperText>
          </FormControl>
        )}

        {/* Target */}
        {!isEdit && (
          <FormControl
            variant="outlined"
            size="small"
            fullWidth
            margin="normal"
            error={!!errors.target}
            disabled={loading}
          >
            <InputLabel>Target</InputLabel>
            <Controller
              name="target"
              control={control}
              defaultValue=""
              rules={{ required: "El target es obligatorio" }}
              as={
                <Select label="Target">
                  {consentType === "ASSIGNMENT" && [
                    <MenuItem value="ORDERS_DOCTORS" key="ORDERS_DOCTORS">
                      Asignación de médicos
                    </MenuItem>,
                    <MenuItem value="ORDERS_PATIENTS" key="ORDERS_PATIENTS">
                      Asignación a pacientes
                    </MenuItem>,
                  ]}

                  {consentType === "REGISTER" && (
                    <MenuItem value="DOCTORS">Médicos</MenuItem>
                  )}
                </Select>
              }
            />
            <FormHelperText>{errors.target?.message}</FormHelperText>
          </FormControl>
        )}

        {/* Archivo */}
        <input
          disabled={loading}
          type="file"
          accept="application/pdf"
          style={{ marginTop: 16, marginBottom: 8, display: "block" }}
          {...register("file", {
            validate: (files) => {
              const valid = isEdit || (files && files.length > 0);
              if (!valid) return "El archivo es obligatorio";
              return true;
            },
          })}
          onChange={(e) => {
            setValue("file", e.target.files); // actualizar valor
            trigger("file"); // revalidar inmediatamente
          }}
        />
        {errors.file && (
          <p style={{ color: "red", fontSize: 12 }}>{errors.file.message}</p>
        )}
        {isEdit && defaultValues?.file && (
          <Typography
            variant="caption"
            style={{ display: "block", marginTop: 6 }}
          >
            Archivo actual: {defaultValues.file}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginTop: 24, textTransform: "none" }}
        >
          {isEdit ? "Actualizar consentimiento" : "Agregar consentimiento"}
        </Button>
      </form>
    </Container>
  );
}
